module.exports = __webpack_public_path__ + "static/media/llama-bg-new.14b8683e.png";